/* UI-DESIGN: restyled with the shared invitation card look (logic unchanged) */
import { useForm } from "react-hook-form";
import GlassPanel from "../../components/lightbox/GlassPanel";
import LightboxButton from "../../components/lightbox/LightboxButton";
import Input from "../../components/input";
import { useNavigate } from "react-router-dom";
import { useLazyGetGameQuery } from "../../reducers/apiSlice";
import convertErrorMessage from "../../utils/convertErrorMessage";
import styles from "./Register.module.scss";

const IdForm = ({ invalidLink = false }: { invalidLink?: boolean }) => {
  const [trigger, { isFetching }] = useLazyGetGameQuery();
  const { register, handleSubmit, formState: { errors }, setError } = useForm();

  const navigate = useNavigate();

  const onSubmit = (data: { game_id?: string }) => {
    trigger(data.game_id as string).then((res: { error?: unknown }) => {
      if (res.error) {
        const convertedError = convertErrorMessage(res.error);
        setError("game_id", { message: convertedError });
      } else {
        navigate(`/register?gameId=${data.game_id}`, { replace: true });
      }
    });
  };

  return (
    <GlassPanel as="form" className={styles.idCard} onSubmit={handleSubmit(onSubmit)} noValidate>
        <h1 className={styles.formTitle}>Find your invitation</h1>
        <p className={styles.formSubtitle}>
          {invalidLink ? "We couldn't open that invitation. Check the game ID with your host and try again." : "Enter the game ID your host shared with you."}
        </p>
        <Input
          label="Game ID"
          labelClassName={styles.fieldLabel}
          inputClassName={styles.field}
          register={register("game_id", { required: "Game ID is required" })}
          error={errors.game_id?.message as string}
          type="text"
          placeholder="Enter Game ID"
        />
        <LightboxButton type="submit" isDisabled={isFetching}>
          {isFetching ? "Finding invitation…" : "Open invitation"}
        </LightboxButton>
    </GlassPanel>
  );
};

export default IdForm;
